var map = {
	"./ABOUKIR3.jpg": 7306,
	"./BEAUREGARD3.jpg": 1984,
	"./COUPOLE3.jpg": 8352,
	"./DROUOT3.jpg": 4893,
	"./GRENELLE3.jpg": 5172,
	"./JACQUEMONT3.jpg": 7860,
	"./PALACIO3.jpg": 8379,
	"./POISSONNIERE I3.jpg": 7333,
	"./POISSONNIERE II3.jpg": 5353,
	"./ST. ANTOINE3.jpg": 1810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6971;